import React,{useState,useEffect} from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow
        ,Card,TextField,Box, Paper,Tooltip,IconButton, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ModalNvoEdit from './ModalNvo';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ModalFoto from './ModalFoto';
import CreateIcon from '@material-ui/icons/Create';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ModalMapa from './ModalMapa';
import ModalAgregarEvidencia from './ModalAgregarEvidencia';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import ModalFotografia from './ModalFotografia';
import moment from 'moment';
const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    estiloCard:{
        width: '80rem',
        boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
       // color:'#4a4a4a',
        display:'block',
        padding:'1rem',
        maxHeight:'100%',
        minHeight: 280,
        marginRight:'1rem'
    },
    formControl:{
        boxSizing:'border-box',
        fontSize:'1rem',
        position:'relative',
        marginBottom:'1em'
    },
    container: {
      width: '78rem',
      minHeight: window.innerHeight-190,
      //minWidth:'100%',
    },
    tablaContainer: {
        width: '78rem',
        maxHeight: window.innerHeight-240,
        minHeight: 280,
        //minWidth:'100%',
      },
    totalEstilo:{
        fontSize:'1.25rem',
        fontWeight:'bold'
    },
    tituloEstilo:{
        paddingBottom:'.25rem',
        fontWeight:'bold'
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      }
    },
    hover: {},
    selected: {}
  });
  const columnas=[              
   /*  { id:1, titulo:"Tipo", alinear:'center'
    },     
    { id:3, titulo:"SubTipo", alinear:'center'    }, */
    { id:1, titulo:"Distrito",alinear:'center'    }, 
    { id:11, titulo:"Barrio",alinear:'center'    }, 
    { id:6, titulo:"OTB",alinear:'center'    }, 
    { id:4, titulo:"Teléfono", alinear:'center'    }, 

    
    { id:2, titulo:"Nombre", alinear:'left'    },     
{ id:11, titulo:"Domicilio", alinear:'center'
    },                 

    
  ];

  const archivo=[{id:0,part:"alianza", dir:"alianza.png"},
    {id:1,part:"individual", dir:"partido_individual.png"},
    {id:2,part:"ap", dir:"ap.webp"},
    {id:3,part:"apb_sumate", dir:"apb_sumate.webp"},
    {id:4,part:"fp", dir:"fp.webp"},
    {id:5,part:"fpv", dir:"fpv.png"},
    {id:6,part:"nulo", dir:"partido_nulo.png"},
    {id:7,part:"izquierda", dir:"izquierda.png"},
    {id:8,part:"libre", dir:"libre.png"},
    {id:9,part:"lyp_adn", dir:"lyp_adn.webp"},
    {id:10,part:"mas_ipsp", dir:"mas_ipsp.webp"},
    {id:11,part:"movimiento", dir:"movimiento.png"},
    {id:12,part:"la paz", dir:"paz.png"},
    {id:13,part:"pdc", dir:"pdc.webp"},
    {id:14,part:"sumate", dir:"sumate.png"},
    {id:15,part:"unidad", dir:"unidad.png"},
    {id:16,part:"pan", dir:"pan.png"}    
  ]
const listSubTipo=[{Id:1,desc:"Delegado"}, {Id:2,desc:"Coordinador"},{Id:3,desc:"Promotor"} ]

const listTipo=[{Id:1, desc:"Distrito"},{Id:2, desc:"SubDistrito"},{Id:3, desc:"OTB"}]

const alturaCont = window.innerHeight<937 ? window.innerHeight-180 : window.innerHeight-200

export default function TablaEstructura({muni,  listPart, getDatos, fSelect}){    
    const classes = useStyles();    
    const [promotor, setPromotor] = useState({nombre:""})
    const [seleccion, setSeleccion] = useState(null)
    const [datos,setDatos] = useState([]);     
    const [modalNvo, setModalNvo] = useState(false);  
    const [modalFoto, setModalFoto] = useState(false);  
    const [actualizar, setActualizar] = useState(false);  
    const [modalMap, setModalMap] = useState(false);  
    const [modalEvidencia, setModalEvidencia] = useState(false);  
    const auxCol=process.env.REACT_APP_Fondo_Color
    const {nombre} = promotor;    
    useEffect(()=>{

        setDatos(muni)

        //la siguiente linea puede generar errores o no en el useEffect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[muni])          

    const onChangeTable =(regis)=>{                       
        setSeleccion(regis)
    }

    function filtro(){        
      let auxCadena=nombre.trim();       
      let info=[];                        
      let aux=  datos.filter((dat)=>dat.Nombre.toUpperCase().search(auxCadena.toUpperCase() ) !== -1)         
      info=aux 
      let auxNum=0;
        if (aux!==null||aux!=='') 
        {
         
      }         
      return TablaEstr(info);
    }

    const onChange = e =>
    {         
        let expNopermitida = new RegExp('[._:$!%-({})/*|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');     
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) 
            && !expMas.test(e.target.value)) || e.target.value===' '||e.target.value==='') 
        {
            setPromotor({
                ...promotor, //copiamos el nombre
                [e.target.name] : e.target.value  
            })
        }
    };

    const celda = (alinear, estilo, contenido,index) => {
        return (
        <TableCell align={alinear} key={index} className={classes.tableCell} 
            padding={'none'} style={estilo} >
            {contenido}
        </TableCell>)
    }
    
  const celdaNvo=()=>{
    return(
    <Tooltip title={`Nuevo `}>
      <IconButton aria-label="agregar nuevo" onClick={() => setModalNvo(true)} 
        component="span" size="small" 
      >
        <AddCircleOutlineIcon style={{color:"white" }} />  
      </IconButton>
    </Tooltip> 
    )
  }

  const partidoFun=(regis)=>{
  //  console.log(regis);
    const filtro =archivo.filter((partido)=>partido.part.toUpperCase() === regis.PartNom.toUpperCase())
    let respues=null
    if (filtro[0]&& filtro[0].length!==0) 
    {
      respues=<img src={`./partidos/${filtro[0].dir}`} style={{width:30,marginTop:".1rem" }} />
    }
    else
    { respues=null//<img src={`./partidos/partido_na.svg`} style={{width:30 }} />
    }
    return respues
  }

  const tipoFun=(regis)=>{
  //  
    const filtro =listTipo.filter((tipo)=>tipo.Id === regis)
    let respues=""
 
    if (filtro[0]&& filtro[0].length!==0) 
    {
      respues=filtro[0].desc
    }
    else
    { respues=""
    }
    return respues
  }

  const subTipoFun=(regis)=>{
  //  
    const filtro =listSubTipo.filter((tipo)=>tipo.Id === regis)
    let respues=""
 
    if (filtro[0]&& filtro[0].length!==0) 
    {
      respues=filtro[0].desc
    }
    else
    { respues=""
    }
    return respues
  }

  const minuscula=(cadena)=>{
    let nvo=""
    nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
    return nvo}

  const CelTitl=({index,titulo,aline})=> celda(aline?aline:"center", {backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 

  function TablaEstr(auxDatos) {        
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
      <Table stickyHeader aria-label="sticky table">
        <TableHead >    
          <TableRow>  
           {/*  <CelTitl index={1} />
            <CelTitl index={2} />
            <CelTitl index={3} /> 
      */}
   
            <CelTitl index={5} titulo={`F. Registro ${auxDatos.length}` } />            
            {columnas.map((columna,index)=>              
              <CelTitl index={index+5} titulo={columna.titulo} aline={columna.alinear} />                          
            )}                                       
          </TableRow>                        
        </TableHead>  
        <TableBody>                                  
        {auxDatos.map((elemnto,index) => {  
          const auxVal=seleccion?.Id === elemnto.Id ?true:false           
              let auxFReg=moment.utc( elemnto.Fecha).format('YYYY-MM-DD HH:mm') === "1900-01-01 00:00"
              ? "" : moment.utc( elemnto.Fecha).format('DD/MM/YYYY HH:mm')                                   
          return (                  
          <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index} onClick={ () => onChangeTable(elemnto) }  
          >   
            {/* celda("center", {width:"2rem"}, 
              elemnto.Fotos!==0?<Tooltip title={`Galeria `}>
              <IconButton aria-label="agregar nuevo" onClick={() => setModalFoto(true)} 
                component="span" size="small" 
              >
                <PhotoLibraryIcon style={{color:auxVal? "white":"" }} color={auxVal? "inherit":"primary" } />  
              </IconButton>
            </Tooltip> :null
            ,index+1)  */}   
              {/* celda("center", {width:"2rem"}, 
              <Tooltip title={`Agregar Evidencia `}>
              <IconButton aria-label="agregar nuevo" onClick={() => setModalEvidencia(true)} 
                component="span" size="small" 
              >
                <AddPhotoAlternateIcon style={{color:auxVal? "white":"" }} color={auxVal? "inherit":"primary" } />  
              </IconButton>
            </Tooltip> 
            ,index+2)  */} 
            {/* celda("center", {width:"2rem"}, 
              elemnto.Lat!==0&&elemnto.Lon!==0?<Tooltip title={`Mapa `}>
              <IconButton aria-label="agregar nuevo" onClick={() => setModalMap(true)} 
                component="span" size="small" 
              >
                <LocationOnIcon style={{color:auxVal? "white":"" }} color={auxVal? "inherit":"primary" } />  
              </IconButton>
            </Tooltip> :null
            ,index+3) */ }   
             {/*  celda("center", {width:"2rem"}, 
            <Tooltip title={`Editar `}>
              <IconButton aria-label="agregar nuevo" onClick={() => setModalNvo(true)} 
                component="span" size="small" 
              >
                <CreateIcon style={{color:auxVal? "white":"" }} color={auxVal? "inherit":"primary" } />  
              </IconButton>
            </Tooltip> 
            ,index+4)   */ }      
            {celda("center", {width:"9rem", paddingRight:".3rem"},   auxFReg , index+6) }                               
            {celda("center", {width:"4rem", paddingRight:".3rem"},   elemnto.DtoNom , index+6) }
            
            {  /* celda("center", {width:"4.5rem"}, subTipoFun(elemnto.SubTipo),index+8)  */} 
            {celda("center", {fontSize:".8rem",width:"10rem"}, elemnto.BarrNom,index+16) }   
            {celda("center", {width:"10rem",fontSize:".8rem"},  elemnto.OtbNom ,index+10) }            
            {celda("center", {width:"5rem"},<a style={{color:auxVal? "white":"black"}} href={`https://api.whatsapp.com/send?phone=591${elemnto.Tel}`}> {elemnto.Tel}</a>,index+9) }    
           
            {celda("left", {fontSize:".7rem"},`${elemnto.Nombre } ${elemnto.Paterno }  ${elemnto.Materno }`,index+7) }            
              {celda("left", {width:"20rem",fontSize:".8rem"},  elemnto.Direcc ,index+10) }
                                    
            
            {/* celda("center", {}, 
              elemnto.PartId!==0? partidoFun(elemnto):""
            ,index+12)  */}         
            {/* celda("center", {width:"2rem"}, elemnto.Genero,index+13) */ }      
           
            {/* celda("left", {fontSize:".7rem"}, elemnto.Tel,index+15) */ }                                                         
          </TableRow>              
          );                        
          })
        }                                                
        </TableBody>
      </Table>
    </TableContainer>        
    ); 
  }
  
  const mostrarVacio =()=>{
    const auxF1 =moment(fSelect.inicio).format('DD/MM/YYYY')
    const auxF2 =moment(fSelect.final).format('DD/MM/YYYY')
    return(
    <Box style={{paddingTop:1+'rem'}}>
      <Typography variant="h4" component="h3">
        {`No contiene datos en el rango de fechas del  `}
      
      </Typography>
      <Typography variant="h4" component="h3">
        {`${auxF1} al ${auxF2}.`}
      </Typography>
      <Typography variant="h4" component="h3">
        {`Seleccione otra fecha a consultar.`}
      
      </Typography>
    </Box>)

  }

    const datGeneral = (<Box display="flex" flexDirection="column"  >
                            {/* seleccionado.length !== 0 ?  
                            <Box display="flex" flexDirection="row" >
                                <DatosCard valor={seleccionado}/>                                                    
                            </Box>
                            :null */}
                            <Box display="flex" flexDirection="row">                                               
                         
                                { /* arregloColor.length>0?
                                <MapDelegacion regSelect={regSelect} arregloColor={arregloColor}/>
                                :null */}
                               {/*  <Box style={{marginLeft:2+'rem'}} pt={1} display="flex" 
                                    flexDirection={"column"}
                                >                                    
                                    <Box >
                                        <Graficas valor={seleccionado}  />                             
                                    </Box> 
                                    <br/>                              
                                </Box>     */}                            
                            </Box>                            
                        </Box>) 


  const modMap = modalMap ? <ModalMapa seleccionado={seleccion} titulo={"Mapa Registro"} subtitulo={""}
                                    setModalAbierto={setModalMap } modalAbierto={modalMap}/> : null;   
    const contenido = nombre.length > 0 ? (filtro()):(TablaEstr(datos));    
    const llamada= datos.length !== 0 ?(contenido):mostrarVacio()
    const modNvo = modalNvo ? 
                        <ModalNvoEdit modalAbierto={modalNvo} setModalAbierto={setModalNvo} getDatos={getDatos}
                            titulo="Editar Registro"     
                            listPart={listPart} auxReg={seleccion}           
                        />:null
  const modFoto =modalFoto ?<ModalFoto modalAbierto={modalFoto} setModalAbierto={setModalFoto} 
                              titulo={`Fotografias ${seleccion.Nom } ${seleccion.Pat }  ${seleccion.Mat }`} seleccionado={seleccion}                                
                            />:null                                                                                        
  /* const modEvidenc = modalEvidencia ? <ModalAgregarEvidencia abrirModal={modalEvidencia} setAbrirModal={setModalEvidencia} registro={seleccion}  
                                    setUpdate={getDatos} />                           
                                :null  */                                                            
  
  const modEvidenc = modalEvidencia ? <ModalFotografia modalAbierto={modalEvidencia} setModalAbierto={setModalEvidencia} seleccionado={seleccion}  
                                        titulo={`Subir Evidencia ${seleccion.Nom } ${seleccion.Pat }  ${seleccion.Mat }`} setActualizar={setActualizar} getDatos={getDatos}
                                        actualizar={actualizar} 
                                      />                           
                                :null                                
                                
  return (
  <Box display={'flex'} flexDirection="row" style={{height: alturaCont}}>
    <Card className={classes.estiloCard} style={{height:window.innerHeight-210}}>                        
      {/*  <TextField className={classes.formControl}
        name="nombre" placeholder="Zona"
        value={nombre} onChange={onChange}
      />	   */}          
      {llamada}   
    </Card>
    {modEvidenc}
    {modMap}
    {modNvo}
    {modFoto}
    {datGeneral}
  </Box>                    
  );
}